<template>
	<div class="binding-body">
		<div class="search-box">
			<div class="input-box">
				<span>员工名称：</span>
				<el-input
					v-model="name"
					placeholder="请输入员工名称"
					class="name-input"
					size="small"
					></el-input>
			</div>
			<div class="input-box">
				<span>员工状态：</span>
				<el-select v-model="status" class="select-box" size='small' placeholder="员工状态">
					<el-option :value="0" label="全部"></el-option>
					<el-option :value="1" label="启用"></el-option>
					<el-option :value="2" label="停用"></el-option>
				</el-select>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="small"
					plain
					@click="tableReload">查询</el-button>
			</div>
			<div class="input-box-btn">
				<el-button
					class="search-btn"
					size="small"
					plain
					@click="clear">清空</el-button>
			</div>
		</div>
		<div class="table-wrap">
			<div class="table-box">
				<el-table
					class="grid-content"
					:data="tableData"
					:height="tableHeight"
					border>
					<el-table-column
					align="center"
					label="选择"
					width="55">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.checkFlag" :disabled="scope.row.stopFlag === true" @change="selectChange(scope.row)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column
						label-class-name = "column-index"
						label="序号"
						type="index"
						width="70"
						align="center">
					</el-table-column>
					<el-table-column
						prop="name"
						label="员工名称"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="code"
						label="员工编号"
						align="center"
						min-width="140">
					</el-table-column>
					<el-table-column
						label="员工状态"
						align="center"
						min-width="130">
						<template slot-scope="scope">
							<span v-if="scope.row.stopFlag === false" style="color:green">启用</span>
							<span v-if="scope.row.stopFlag === true" style="color:red">停用</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="table-box">
				<el-table
					class="grid-content"
					:data="checkArr"
					:height="tableHeight"
					border>
					<el-table-column
					align="center"
					label="选择"
					width="55">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.checkFlag" :disabled="scope.row.stopFlag === true" @change="selectChange(scope.row)" ></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column
						label-class-name = "column-index"
						label="序号"
						type="index"
						width="70"
						align="center">
					</el-table-column>
					<el-table-column
						prop="name"
						label="员工名称"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="code"
						label="员工编号"
						align="center"
						min-width="140">
					</el-table-column>
					<el-table-column
						label="员工状态"
						align="center"
						min-width="130">
						<template slot-scope="scope">
							<span v-if="scope.row.stopFlag === false" style="color:green">启用</span>
							<span v-if="scope.row.stopFlag === true" style="color:red">停用</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
         <div class="binding-foot">
            <el-button class="btn" plain type="primary" @click="cancelClick">取消</el-button>
            <el-button class="btn" plain type="primary" @click="saveClick">保 存</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'binding',
	props: {
		bindId: String,
		isShow: Boolean
	},
	data () {
		return {
			roleId: '',
			name: '',
			status: 0,
			tableData: [],
			checkArr: [],
			tableHeight: '100%',
			firstFlag: false
		}
	},
	watch: {
		bindId: {
			handler (val) {
				this.roleId = val
			},
			immediate: true
		},
		isShow: {
			handler (val) {
				if (val === true) {
					this.name = ''
					this.status = 0
					this.firstFlag = true
					this.tableReload()
					this.checkArr = this.tableData.filter(item => {
						return item.checkFlag
					})
				} else {
					this.tableData = []
					this.firstFlag = false
				}
			},
			immediate: true
		}
	},
	methods: {
		clear () {
			this.name = ''
			this.status = 0
			this.tableReload()
		},
		tableReload () {
			let params = {
				name: this.name,
				state: this.status,
				roleId: this.roleId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserInfo`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData = res.data
					if (this.firstFlag) {
						this.checkArr = this.tableData.filter(item => {
							return item.checkFlag
						})
						this.firstFlag = false
					} else {
						const arr = this.checkArr.map(item => {
							return item.id
						})
						this.tableData.forEach(item => {
							if (arr.indexOf(item.id) !== -1) {
								item.checkFlag = true
							}
						})
					}
					// this.selectChange()
				}
			})
		},
		selectChange (row) {
			// this.checkArr = this.tableData.filter(item => {
			// 	return item.checkFlag
			// }).concat(this.checkArr)
			if (row.checkFlag) {
				this.checkArr.push(row)
			} else {
				const checkIndex = this.checkArr.findIndex(item => {
					return item.id === row.id
				})
				this.checkArr.splice(checkIndex, 1)
			}
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveClick () {
			// this.selectChange()
			let params = {
				roleId: this.bindId,
				ids: this.checkArr.map(item => {
					return item.id
				})
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/saveRoleUser`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$emit('cancel', false)
					this.$message.success('保存成功')
				} else {
					this.$message.console.error(res.msg)
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    // width :660px;
	flex-direction: column;
    overflow-y :auto;
	.search-box{
		margin-bottom :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :80px;
		}
		.input-box{
			margin-left :10px;
			width :265px;
			margin-bottom:10px
			.name-input {
				width: 180px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
		}
	}
	.table-wrap {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
	}
    .table-box{
		width: calc(50% - 10px)
        height: 350px;
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top: 20px;
        // margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left: 65px;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
